var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 1.49976C21.8284 1.49976 22.5 2.17133 22.5 2.99976V20.9998C22.5 21.8282 21.8284 22.4998 21 22.4998H3C2.17157 22.4998 1.5 21.8282 1.5 20.9998V2.99976C1.5 2.17133 2.17157 1.49976 3 1.49976H21ZM3 -0.000244141C1.34315 -0.000244141 0 1.3429 0 2.99976V20.9998C0 22.6566 1.34315 23.9998 3 23.9998H21C22.6569 23.9998 24 22.6566 24 20.9998V2.99976C24 1.3429 22.6569 -0.000244141 21 -0.000244141H3Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.2498C6.33579 11.2498 6 11.5855 6 11.9998C6 12.414 6.33579 12.7498 6.75 12.7498H17.25C17.6642 12.7498 18 12.414 18 11.9998C18 11.5855 17.6642 11.2498 17.25 11.2498H6.75Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.dbc0b15a85afb7ba14806867e259195f.svg";
export { ForwardRef as ReactComponent };